module.exports = {"140928100":"砚城镇","140928101":"小河头镇","140928102":"三岔镇","140928200":"前所乡","140928201":"李家坪乡","140928202":"孙家坪乡","140928204":"胡会乡","140928206":"韩家楼乡","140928207":"东秀庄乡","140928208":"杏岭子乡","140928400":"五寨县居民"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140928.json
// module id = 442
// module chunks = 0